<!-- 院内处方流转1.0新增组件 -->
<template>
  <div class="record-warp">
    <div
      class="flex align-center year-row"
      v-if="(yearScope == '全部' && recordList && recordList.length) || yearScope !== '全部'"
      @click="showPicker = true"
    >
      <span class="year">{{ yearScope }}</span>
      <van-icon name="cap-arrow-down" />
    </div>
    <div class="record-list" v-if="recordList && recordList.length > 0">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多病历了" @load="onLoad">
        <record-item v-for="(item, key) in recordList" :medicalRecord="item" :key="key" />
      </van-list>
    </div>
    <van-empty
      class="flex center"
      v-else-if="recordList && recordList.length == 0"
      :image="require('@/assets/imgs/list-empty.png')"
      :description="description"
    />
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
    </van-popup>
  </div>
</template>

<script>
import RecordItem from './components/recordItem.vue';
export default {
  name: 'record-list',
  components: {
    RecordItem
  },
  data() {
    return {
      recordList: [],
      loading: false,
      finished: false,
      pageNo: 1,
      pageSize: 20,
      description: '暂无病历记录',
      columns: [],
      showPicker: false,
      yearScope: '全部',
      firstRecordYear: ''
    };
  },
  created() {
    this.getFirstRecordYear();
    this.initData();
  },

  methods: {
    async getFirstRecordYear() {
      const firstRecordYear = await this.$fetch.fetchGetFirstRecordYear({ archiveId: this.$route.query.archiveId });
      const nowYear = new Date().getFullYear();
      const columns = ['全部'];
      this.firstRecordYear = parseInt(firstRecordYear) || nowYear;
      for (let i = nowYear; i >= this.firstRecordYear; i--) {
        columns.push(i);
      }
      this.columns = columns;
    },
    initData() {
      this.finished = false;
      this.loading = true;
      this.pageNo = 1;
      this.onLoad();
    },
    async onLoad() {
      await this.fetchData();
      this.loading = false;
      this.pageNo += 1;
    },
    onConfirm(value, index) {
      this.yearScope = value;
      this.showPicker = false;
      this.initData();
    },
    async fetchData() {
      const { archiveId } = this.$route.query;

      const { data, totalCount } = await this.$fetch.fetchGetMedicalRecord({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        archiveId,
        year: this.yearScope == '全部' ? '' : this.yearScope
      });
      // 放在这里避免先出现暂无处方的提示
      if (this.pageNo === 1) {
        this.recordList = [];
      }
      if (data) this.recordList.push(...data);
      if (totalCount <= this.pageNo * this.pageSize) {
        this.finished = true;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.record-warp {
  padding: 0 16px;
  .year-row {
    height: 48px;
    .year {
      font-weight: 400;
      color: #262626;
      margin-right: 10px;
      font-size: 16px;
    }
  }
}
</style>
